import { OpportunityDetailModel } from "types/models/OpportunityDetailModel";
import {StudentPoolItem} from './StudentPoolItem';

export class OpportunityStudentListView implements IOpportunityStudentListView {
  opportunity?: OpportunityDetailModel | undefined;
  poolStudents?: StudentPoolItem[] | undefined;

  constructor(data?: IOpportunityStudentListView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.opportunity = Data["opportunity"] ? OpportunityDetailModel.fromJS(Data["opportunity"]) : <any>undefined;
      if (Array.isArray(Data["poolStudents"])) {
        this.poolStudents = [] as any;
        for (let item of Data["poolStudents"])
          this.poolStudents!.push(StudentPoolItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OpportunityStudentListView {
    data = typeof data === 'object' ? data : {};
    let result = new OpportunityStudentListView();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
    if (Array.isArray(this.poolStudents)) {
      data["poolStudents"] = [];
      for (let item of this.poolStudents)
        data["poolStudents"].push(item.toJSON());
    }
    return data;
  }
}

export interface IOpportunityStudentListView {
  opportunity?: OpportunityDetailModel | undefined;
  poolStudents?: StudentPoolItem[] | undefined;
}